import { atom } from 'recoil';

export const createAppointmentModalStateAtom = atom({
  key: 'createAppointmentModalStateAtom',
  default: {
    open: false,
  },
});
